const CourseModulesSkeleton = () => (
  <div className={'flex animate-pulse gap-7'}>
    <div className={'bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent'}>.</div>
    <div className={'bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent'}>.</div>
    <div className={'bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent'}>.</div>
    <div className={'bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent'}>.</div>
  </div>
)

export default CourseModulesSkeleton
